/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';

import { Theme } from '../constants/theme';

@Injectable()
export class ThemesService {
    themes = {
        aui: Theme.AUI,
        'simple-mode': Theme.SIMPLE_MODE,
    };

    /** 组件库css打包路径 */
    coreCssPath = 'css/themes/core/';

    /** 主题初始化 */
    initTheme(theme?: Theme): void {
        const insetTheme = theme || Object.values(this.themes)[0];
        this.createLinkLabel(insetTheme);
        this.changeProdTheme(insetTheme);
    }

    /** 创建link标签 */
    createLinkLabel(theme: Theme): void {
        const head = document.getElementsByTagName('head')[0];
        const link = document.createElement('link');
        link.dataset.type = 'theme';
        link.rel = 'stylesheet';
        link.type = 'text/css';

        if (theme === Theme.AUI) {
            link.href = '';
            head.insertBefore(link, head.lastChild);
            return;
        }

        link.href = `${this.coreCssPath}${theme}/index.css`;
        head.insertBefore(link, head.lastChild);
    }

    /** 主题切换 */
    changeTheme(theme: Theme): void {
        if (!this.themes[theme]) {
            return;
        }
        this.changeCoreTheme(theme);
        this.changeProdTheme(theme);
    }

    /** dm/core 主题切换 */
    changeCoreTheme(theme: Theme): void {
        const link = document.querySelector('[data-type="theme"]') as HTMLLinkElement;

        if (theme === Theme.AUI) {
            link.href = '';
            return;
        }

        link.href = `${this.coreCssPath}${theme}/index.css`;
    }

    /** 业务代码主题切换 */
    changeProdTheme(theme: Theme): void {
        const body = document.getElementsByTagName('body')[0];
        body.setAttribute('theme-style', theme);
    }
}
